export function getSentryEnvironment({
  isProd,
  isStaging,
  isDev,
}: {
  isProd: boolean;
  isStaging: boolean;
  isDev: boolean;
}): string {
  if (isDev) return 'dev';
  if (isStaging) return 'staging';
  if (isProd) return 'prod';
  return 'staging';
}
